import React from "react";
import BaseSettingsPage from "../../BaseSettingsPage";
import OnboardingNavigation from "../OnboardingNavigation";
import { StepHeader } from "./index";

class GetInvolved extends React.Component {
  handleSaveResults = results => {
    if (results && !results.hasError) {
      return this.props.goForward();
    }
    return null;
  };

  render() {
    return (
      <div>
        <StepHeader>
          We may have opportunities for you to get involved.
        </StepHeader>
            <BaseSettingsPage
              showCard={true}
              category="GetInvolved"
              handleSaveResults={this.handleSaveResults}
              headerText="I am Willing To"
              renderSaveButton={saveHandler => (
                <OnboardingNavigation {...this.props} goForward={saveHandler} />
              )}
            />
      </div>
    );
  }
}

export default GetInvolved;



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/Steps/GetInvolved.js